import styled from 'styled-components'

const ItemListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  overflow-y: auto;
  padding-left: 8px;
  overflow-x: hidden; /* remove scroll horizontal */

  .fixed-list {
    overflow-x: hidden !important;
  }
  .fixed-list::-webkit-scrollbar {
    width: 4px;
    background-color: none;
    border-radius: 100px;
  }
  .fixed-list::-webkit-scrollbar-track {
    background: none;
    margin-top: 8px;
    border: 0;
  }
  .fixed-list::-webkit-scrollbar-thumb {
    width: 8px;
    background-color: #c4c4c4;
    border-radius: 50px;
  }
`
export { ItemListContainer }
